export class StartedEvent {
    constructor({ transfer, startedDate }) {
        this.name = 'started';
        this.transfer = { ...transfer };
        this.startedDate = startedDate;
    }
    get data() {
        return {
            transfer: this.transfer,
            startedDate: this.startedDate,
        };
    }
}
